const Ajax = window.util.ajax;
const __work = {
    page: 1,
    showLayerMedia() {
        let url = $(this).data("video");
        let poster = $(this).find("img").attr("src");

        layer.open({
            type: 1,
            title: false,
            area: ["800px", 'auto'],
            offset: 'auto',
            closeBtn: 0,
            shadeClose: true,
            skin: 'yourclass',
            content: `<div class="video-layer">
                        <div id="videoPlay" style="width: 800px;height: 450px;">
                        </div>
                      </div>`,
            success: function(layero, index) {

                new QPlayer({
                    url: url, // 直播流
                    container: document.getElementById("videoPlay"),
                    autoplay: false,
                    noControls: false,
                    poster: poster // 封面图
                });
            }
        });
    },
    getResourceList() {
        Ajax({
            url: '/party/ajaxGetArticleList',
            data: {
                page:__work.page,
                category: '53',
                category_two:'282'
            },
            dataType: "json",
            type: 'get',
            callback(res) {
                if (res.code === 0) {
                    let data = res.data;

                    if(data.length > 0) {
                        $('._resourceList').append(__work.creatHTML(data));
                        __work.page++;
                    }else{
                        $('._resourceMore').html('暂无更多')
                    }
                } else {
                    layer.msg(res.msg);
                }
            },
            error: (res) => {
                layer.msg(res.data);
            }
        });
    },
    creatHTML(data){
        let html = '';

        data.forEach(item=>{
            html+=`<a href="${item.url}" target="_blank">${item.title}</a>`;
        })

        return html;
    }
}

$(() => { 
    if($('._resourceList').length){
        __work.getResourceList();
    }
    $(document)
        // 视频弹层
        .on("click", "._showLayerMedia", __work.showLayerMedia)
        .on("click", "._resourceMore", __work.getResourceList)
});